














import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {CurrentPresentation} from "@api/models/interfaces/web-conference/CurrentPresentation";
import {getBackend} from "@service/router/getters";
import {getImageUrl} from "@common/ImageUrlHelper";
import ImageView from "@share/common/ImageView.vue";

@Component({
    name: "AudienceViewer",
    components: {ImageView}
})
export default class AudiencePresentationViewer extends Vue {
    @Prop({required: true}) currentPresentation: CurrentPresentation;

    oldFileId = '';

    get backend() {
        return getBackend(this.$route.params.backend)
    }

    get currentSlideFileId() {
        return this.currentPresentation?.data?.currentSlideFileId;
    }

    get imgUrl() {
        if (this.oldFileId) {
            return getImageUrl(this.backend, this.oldFileId);
        }

        return this.currentImgUrl;
    }

    get currentImgUrl() {
        if (this.currentSlideFileId) {
            return getImageUrl(this.backend, this.currentSlideFileId);
        }

        return '';
    }

    @Watch('currentSlideFileId')
    onCurrentSlideFileIdChanged(newFileId: string, oldFileId: string) {
        if (newFileId) {
            this.oldFileId = oldFileId;
        }
    }

    onLoaded() {
        this.oldFileId = '';
    }
}
